const Container = (props) => {
    const { children } = props;
    return (
        <div className={`${props.bgColor || "bg-eblack"}`}>
            <div className={`${props.bgColor || "bg-eblack"} ${props.className} max-w-screen-2xl mx-auto `}>
                {children}
            </div>
        </div>
    );
}

export default Container;